// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2vMkb","rootSmall":"AddTileButton_rootSmall__1TyqV"};